module.exports = __webpack_public_path__ + "assets/1a6ff7819edea9450e220bf11d0492e5.jpg";